import { FC, Fragment, useEffect } from "react";
import { FormContainer } from "../../../../shared/components/formContainer";
import { useFormik } from "formik";
import { customizeValidationSchema } from "../variables/customSchema";
import useMutation from "../../../../shared/components/hooks/useMutation";
import { ProfileBorderBox } from "../../../../shared/components/profileComponents";
import { getTextFields } from "../variables/textFields";
import { Grid } from "@mui/material";
import InputTextfield from "../../../../shared/components/textField";
const ResellerForm: FC = () => {
  const { loading: apiLoading, modifyData } = useMutation("resellers");

  const initialValues = {
    name: "",
    phone: "",
    email: "",
    subdomainName: "",
  };

  const resellerForm = useFormik({
    initialValues: initialValues,
    validationSchema: customizeValidationSchema(),
    enableReinitialize: true,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (formData: any) => {
      await modifyData(
        `/admin/organization`,
        "post",
        {
          ...formData,
        },
        resellerForm
      );
    },
  });

  const titleBar = {
    headerTitle: "Reseller - Create",
    title: " Create Reseller ",
    buttonTitle: "Save",
    onClick: () => resellerForm.handleSubmit(),
    dirty: resellerForm.dirty,
    buttonLoading: apiLoading,
  };
  const textFields = getTextFields({});
  useEffect(() => {
    const companyName = resellerForm.values.name;
    if (companyName) {
      const sanitizedDomain = companyName
        .toLowerCase()
        .split(" ")[0]
        .replace(/[^a-z0-9]+/g, "");
      resellerForm.setFieldValue("subdomainName", sanitizedDomain);
    }
  }, [resellerForm.values.name]);

  return (
    <>
      <ProfileBorderBox>
        <FormContainer titleBar={titleBar}>
          <Grid
            container
            alignItems="stretch"
            columnSpacing={4}
            rowSpacing={2}
            sx={{ pt: 3 }}
          >
            {textFields.map((field: any, index: number) => (
              <Fragment key={field.id}>
                {(field?.formField === undefined ||
                  field.formField === true) && (
                  <Grid item md={6} sm={6} xs={12}>
                    <InputTextfield
                      form={resellerForm}
                      fieldProps={field}
                      key={index}
                    />
                  </Grid>
                )}
              </Fragment>
            ))}
          </Grid>
        </FormContainer>
      </ProfileBorderBox>
    </>
  );
};

export default ResellerForm;
